import http from './http';

class ReservationsService {
    getEvents(params) {
        return http.get('/user/reservations/events', { params });
    }

    getReservations(params) {
        return http.get('/user/reservations', { params });
    }

    getReservationsAdmin(params) {
        return http.get('/user/reservations/admin', { params });
    }

    getReservation(reservationId) {
        return http.get(`/user/reservations/${reservationId}`);
    }

    createSingle(payload) {
        return http.post('/user/reservations/single', payload);
    }

    createFixed(payload) {
        return http.post('/user/reservations/fixed', payload);
    }

    getStatus(reservationId) {
        return http.get(`/user/reservations/${reservationId}/status`);
    }

    checkRoomAvailability(params) {
        return http.get('/user/reservations/availability', { params });
    }

    updateReservation(reservationId, payload) {
        return http.put(`/user/reservations/${reservationId}`, payload);
    }

    cancelReservation(bookingId, cancelAll = false) {
        return http.delete(`/user/reservations/${bookingId}?all=${cancelAll}`);
    }
    
    sendMultiplePayment(payload) {
        return http.post('/user/payments/multiple', payload);
    }
}

export default new ReservationsService();
